export default __webpack_public_path__ + "static/media/flag.642caf47.svg";